import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-beige-light relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-green-light/30 via-beige-light to-beige-light pointer-events-none" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-green-dark mb-8 leading-tight" data-id="element-95">
            El próximo lunes puedes seguir improvisando...
            <br data-id="element-96" />
            <span className="text-green-medium" data-id="element-97">
              O puedes entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-dark-border/10" data-id="element-98">
            {['Sin más noches buscando ejemplos latinoamericanos de cambio climático, biodiversidad o economía circular', 'Sin más clases armadas de apuro con material genérico que no habla de la realidad de tus alumnos', 'Sin más alumnos desconectados que no entienden por qué la crisis ambiental los afecta a ellos', 'Sin más fines de semana perdidos construyendo actividades y evaluaciones desde cero', 'Sin más silencios incómodos frente a preguntas sobre glaciares, derechos de la naturaleza o huella ecológica que te ponen en aprietos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                <span className="text-gold mt-1" data-id="element-100">▸</span>
                <span className="text-dark/80" data-id="element-101">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-dark/80 mb-2" data-id="element-102">
            El Mega Pack Educación Ambiental y Sostenibilidad en el Aula no te
            convierte en mejor docente.
          </p>
          <p className="text-2xl font-bold text-green-dark mb-6" data-id="element-103">
            Vos ya eres un buen docente.
          </p>
          <p className="text-xl text-dark/80 mb-16" data-id="element-104">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase.
          </p>
        </div>

        <div className="bg-white border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-105">
          <h3 className="text-2xl font-bold text-green-dark mb-6 text-center border-b border-dark-border/10 pb-6" data-id="element-106">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107">
            {['Tomo 1 — Geopolítica y Ciencia del Cambio Climático', 'Tomo 2 — Biodiversidad y Ecosistemas Neotropicales', 'Tomo 3 — Gestión de Recursos, Energía y Economía Circular', 'Tomo 4 — Sostenibilidad Urbana y Huella Ecológica', 'Tomo 5 — Ética Ambiental, Legislación y Ciudadanía Activa', 'Bono A — Paquete de Actividades Integradoras', 'Bono B — Paquete Completo de Evaluaciones y Rúbricas', 'Bono C — Glosario Técnico Ambiental', 'Bono D — Proyectos Anuales Completos', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                <Check size={18} className="text-gold shrink-0" data-id="element-109" />
                <span className="text-sm text-dark/80" data-id="element-110">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111">
            <div className="mb-8 p-6 bg-green-light/30 rounded-xl border border-green-medium/20 italic text-dark/80 text-lg" data-id="element-112">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" />
              <span className="text-green-dark font-bold not-italic" data-id="element-114">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-green-dark mb-2" data-id="element-115">
              📚 Mega Pack Educación Ambiental y Sostenibilidad en el Aula
            </p>
            <p className="text-sm text-dark/60 mb-8" data-id="element-116">
              Hecho por especialistas, para docentes de secundaria y
              bachillerato de todo el mundo hispanohablante.
            </p>

            <Button href="#pricing" className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-dark/50" data-id="element-118">
              <span data-id="element-119">✅ Garantía de 7 días</span>
              <span data-id="element-120">✅ Pago seguro</span>
              <span data-id="element-121">✅ Acceso inmediato</span>
              <span data-id="element-122">✅ Pagas en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}